var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "bl-session-base" },
    [
      _vm.pageLoading
        ? _c(
            "div",
            {
              staticClass:
                "fixed top-0 left-0 grid w-screen h-screen place-items-center bg-light-purple-100",
              style: { zIndex: 999 }
            },
            [
              _c(
                "div",
                {
                  staticClass:
                    "flex items-center text-4xl font-bold font-logo text-light-purple animate-pulse"
                },
                [_vm._v("\n      Blüm Session\n    ")]
              )
            ]
          )
        : _c(
            "div",
            {
              staticClass:
                "fixed top-0 left-0 flex flex-col w-screen h-screen bg-light-purple-100",
              style: { zIndex: 999 }
            },
            [
              _vm.session && _vm.client
                ? _c(
                    "div",
                    {
                      staticClass:
                        "flex flex-row items-center justify-between flex-shrink-0 w-full h-12 gap-4 px-4 border-b lg:h-20 lg:px-12 bg-pure-white border-slate-400",
                      attrs: { id: "session-header" }
                    },
                    [
                      _c(
                        "div",
                        { staticClass: "flex items-center gap-4" },
                        [
                          _c("BlInputButton", {
                            staticClass: "hidden lg:flex",
                            attrs: { type: "plain", icon: "close" },
                            on: { clicked: _vm.exitSession }
                          }),
                          _vm._v(" "),
                          _c("Avatar", {
                            staticClass: "hidden lg:flex",
                            attrs: {
                              name: _vm.client.name,
                              status: _vm.client.status,
                              size: 32
                            }
                          }),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass: "flex truncate lg:max-w-32",
                              attrs: { title: _vm.client.name }
                            },
                            [
                              _c("BlTextSubtitle2", {
                                staticClass: "truncate",
                                attrs: { text: _vm.client.name }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          !_vm.session.user
                            ? _c("BlTextBody2", {
                                staticClass: "hidden italic lg:flex",
                                attrs: { text: "Deleted user" }
                              })
                            : _c(
                                "div",
                                {
                                  staticClass:
                                    "flex-wrap items-center flex-shrink-0 hidden h-8 px-2 truncate border rounded lg:flex bg-success-100 border-success-100 max-w-32",
                                  attrs: {
                                    title:
                                      _vm.session.user.name ||
                                      _vm.session.user.email
                                  }
                                },
                                [
                                  _c("BlTextBody2", {
                                    staticClass: "truncate text-success",
                                    attrs: {
                                      text:
                                        _vm.session.user.name ||
                                        _vm.session.user.email
                                    }
                                  })
                                ],
                                1
                              ),
                          _vm._v(" "),
                          _c("div", {
                            staticClass: "h-8 w-0.5 hidden lg:flex bg-grey-200"
                          }),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass:
                                "flex items-center flex-shrink-0 gap-2"
                            },
                            [
                              _c("div", {
                                staticClass:
                                  "bl-time-indicator h-2 w-2 lg:h-3.5 lg:w-3.5 flex-shrink-0 rounded-full",
                                class: {
                                  "bl-time-indicator-recording": !_vm.isEnded
                                },
                                style: { backgroundColor: "#EAECF0" }
                              }),
                              _vm._v(" "),
                              _c("BlTextBody1", {
                                staticClass: "flex-shrink-0 hidden lg:flex",
                                attrs: {
                                  text: _vm.isEnded ? "Recorded" : "Recording"
                                }
                              }),
                              _vm._v(" "),
                              _c("BlTextBody1", {
                                staticClass:
                                  "flex-shrink-0 text-xs lg:text-base",
                                attrs: { text: _vm.recordingTime }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass:
                                "items-center flex-shrink-0 hidden gap-2 lg:flex"
                            },
                            [
                              _c("BlIcon", {
                                staticClass: "w-4 h-4",
                                attrs: { icon: "calendar-blank" }
                              }),
                              _vm._v(" "),
                              _c("BlTextBody1", {
                                attrs: {
                                  text: _vm.displayDate(
                                    _vm.session.start_time ||
                                      _vm.session.created_at,
                                    "DD/MM/YYYY"
                                  )
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "items-center hidden gap-2 lg:flex" },
                        [
                          _c("BlInputButton", {
                            attrs: { label: "Share session", type: "plain" },
                            on: {
                              clicked: function($event) {
                                _vm.shareOpened = !_vm.shareOpened
                              }
                            }
                          }),
                          _vm._v(" "),
                          _c("BlInputButton", {
                            attrs: {
                              label: _vm.isEnded
                                ? "Session has ended"
                                : "End session",
                              disabled:
                                _vm.isEnded ||
                                _vm.updatingMeasurementIds.length > 0
                            },
                            on: { clicked: _vm.openEndSession }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c("BlInputButton", {
                        staticClass: "lg:hidden",
                        attrs: {
                          label: _vm.isEnded ? "Ended" : "End",
                          dense: "",
                          disabled:
                            _vm.isEnded || _vm.updatingMeasurementIds.length > 0
                        },
                        on: { clicked: _vm.openEndSession }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass:
                    "flex flex-shrink-0 w-full h-12 gap-4 px-6 pt-2 border-b bg-pure-white border-slate-400"
                },
                _vm._l(_vm.tabs, function(tab) {
                  return _c(
                    "router-link",
                    {
                      key: tab.target,
                      staticClass:
                        "flex items-center justify-center w-full transition-all duration-300 border-b-4",
                      class: [
                        tab.isActive
                          ? "border-light-purple"
                          : "border-pure-white"
                      ],
                      attrs: { to: tab.target }
                    },
                    [
                      tab.isActive
                        ? _c("BlTextSubtitle2", { attrs: { text: tab.label } })
                        : _c("BlTextBody1", { attrs: { text: tab.label } })
                    ],
                    1
                  )
                }),
                1
              ),
              _vm._v(" "),
              _c("div", { staticClass: "relative w-full" }, [
                _c(
                  "div",
                  {
                    staticClass:
                      "grid content-start gap-4 p-4 lg:p-8 md:grid-cols-2 lg:grid-cols-4"
                  },
                  [
                    _vm.measurementFixed
                      ? _c(
                          "div",
                          {
                            staticClass:
                              "fixed bottom-0 left-0 z-20 flex-shrink-0 w-screen lg:w-auto lg:relative",
                            style:
                              _vm.viewMode === "desktop"
                                ? { height: "calc(100vh - 5rem - 3rem - 4rem)" }
                                : { height: "auto" }
                          },
                          [
                            _c("MeasurementCard", {
                              key: _vm.measurementFixed.id,
                              staticClass: "relative w-full h-full",
                              attrs: {
                                measurement: _vm.measurementFixed,
                                sessionStatus: _vm.session.status,
                                isRunning: _vm.runningDurationIds.includes(
                                  _vm.measurementFixed.id
                                ),
                                count: _vm.counter
                              },
                              on: {
                                "toggle-updated": function($event) {
                                  return _vm.onToggleUpdatedMeasurment($event)
                                },
                                "toggle-running": function($event) {
                                  return _vm.onToggleRunningDuration(
                                    _vm.measurementFixed.id
                                  )
                                },
                                "toggle-saved": function($event) {
                                  return _vm.onToggleSavedSbt($event)
                                },
                                "exit-session": _vm.exitSession
                              }
                            })
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass:
                          "relative grid content-start gap-6 pt-4 overflow-y-auto -top-4 lg:-top-8 pb-128 lg:pt-8 lg:pb-0 md:grid-cols-2 md:col-span-2 scrollbar-none",
                        class: [
                          _vm.measurementFixed
                            ? "lg:grid-cols-3 lg:col-span-3"
                            : "lg:grid-cols-4 lg:col-span-4"
                        ],
                        style: { height: "calc(100vh - 5rem)" }
                      },
                      _vm._l(_vm.measurementCount, function(i, idx) {
                        return _c(
                          "div",
                          {
                            key: idx,
                            staticClass: "relative w-full h-full",
                            style:
                              _vm.viewMode === "desktop"
                                ? { aspectRatio: "100 / 160" }
                                : {}
                          },
                          [
                            _vm.measurementsOther[idx]
                              ? _c("MeasurementCard", {
                                  staticClass: "w-full h-full",
                                  attrs: {
                                    measurement: _vm.measurementsOther[idx],
                                    sessionStatus: _vm.session.status,
                                    isRunning: _vm.runningDurationIds.includes(
                                      _vm.measurementsOther[idx].id
                                    ),
                                    count: _vm.counter
                                  },
                                  on: {
                                    "toggle-updated": function($event) {
                                      return _vm.onToggleUpdatedMeasurment(
                                        $event
                                      )
                                    },
                                    "toggle-running": function($event) {
                                      return _vm.onToggleRunningDuration(
                                        _vm.measurementsOther[idx].id
                                      )
                                    },
                                    "toggle-saved": function($event) {
                                      return _vm.onToggleSavedSbt($event)
                                    },
                                    "exit-session": _vm.exitSession
                                  }
                                })
                              : _c("div", {
                                  staticClass:
                                    "absolute top-0 left-0 w-full h-full border rounded border-light-purple"
                                })
                          ],
                          1
                        )
                      }),
                      0
                    )
                  ]
                ),
                _vm._v(" "),
                _vm.activeTab === "comments" && _vm.session
                  ? _c(
                      "div",
                      {
                        staticClass:
                          "absolute top-0 left-0 z-50 flex justify-center w-screen py-6 overflow-y-auto bg-light-purple-100",
                        style:
                          _vm.viewMode === "desktop"
                            ? { height: "calc(100vh - 8rem)" }
                            : { height: "calc(100vh - 6rem)" }
                      },
                      [
                        _c("SessionRecordComments", {
                          attrs: { sessionId: _vm.session.id }
                        })
                      ],
                      1
                    )
                  : _vm._e()
              ])
            ]
          ),
      _vm._v(" "),
      _vm.endSessionInterceptOpened
        ? _c(
            "BlBackdrop",
            {
              attrs: {
                title: "Can't end this session",
                type: "error",
                footer: false
              }
            },
            [
              _c("div", { staticClass: "px-4 lg:px-8" }, [
                _c(
                  "div",
                  { staticClass: "flex flex-col gap-1" },
                  [
                    _c("BlTextBody2", {
                      attrs: {
                        text:
                          "You can't end the session because of the following reason(s):"
                      }
                    }),
                    _vm._v(" "),
                    _vm.runningDurationIds.length
                      ? _c(
                          "div",
                          { staticClass: "flex items-center gap-2 px-2" },
                          [
                            _c("div", {
                              staticClass:
                                "flex-shrink-0 w-1 h-1 rounded bg-slate-800"
                            }),
                            _vm._v(" "),
                            _c("BlTextBody2", {
                              attrs: { text: "Timer is still running" }
                            })
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.probInterceptMessage === "minimum_required_trials" ||
                    _vm.probInterceptMessage === "both"
                      ? _c(
                          "div",
                          { staticClass: "flex items-center gap-2 px-2" },
                          [
                            _c("div", {
                              staticClass:
                                "flex-shrink-0 w-1 h-1 rounded bg-slate-800"
                            }),
                            _vm._v(" "),
                            _c("BlTextBody2", {
                              attrs: {
                                text:
                                  "Minimum required probes have not been met"
                              }
                            })
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.probInterceptMessage === "selected_and_saved" ||
                    _vm.probInterceptMessage === "both"
                      ? _c(
                          "div",
                          { staticClass: "flex items-center gap-2 px-2" },
                          [
                            _c("div", {
                              staticClass:
                                "flex-shrink-0 w-1 h-1 rounded bg-slate-800"
                            }),
                            _vm._v(" "),
                            _c("BlTextBody2", {
                              attrs: {
                                text:
                                  "Actions for the probing have not been saved"
                              }
                            })
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.unsavedSbtIds.length
                      ? _c(
                          "div",
                          { staticClass: "flex items-center gap-2 px-2" },
                          [
                            _c("div", {
                              staticClass:
                                "flex-shrink-0 w-1 h-1 rounded bg-slate-800"
                            }),
                            _vm._v(" "),
                            _c("BlTextBody2", {
                              attrs: {
                                text:
                                  "The target with SBT hasn't saved its result"
                              }
                            })
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _c("BlTextBody2", {
                      attrs: {
                        text:
                          "Please address these issues before ending the session."
                      }
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "flex justify-end py-4 lg:py-8" },
                  [
                    _c("BlInputButton", {
                      attrs: { label: "Back to session" },
                      on: {
                        clicked: function($event) {
                          _vm.endSessionInterceptOpened = false
                        }
                      }
                    })
                  ],
                  1
                )
              ])
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.emptyMeasurmentsOpened
        ? _c(
            "BlBackdrop",
            {
              attrs: {
                title: "It seems you haven't recorded any data",
                footer: false
              }
            },
            [
              _c(
                "div",
                { staticClass: "px-4 lg:px-8", style: { width: "40rem" } },
                [
                  _c(
                    "div",
                    {
                      staticClass:
                        "flex flex-col-reverse items-center justify-center gap-4 lg:flex-col"
                    },
                    [
                      _c(
                        "div",
                        [
                          _c("BlTextBody2", {
                            attrs: {
                              text:
                                "Please note that if you end the session now, the targets will record the data as ''0''. To prevent any data recording, you can deactivate the toggle on each target. Would you like to turn off the toggle for all targets?"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c("img", {
                        staticClass:
                          "w-auto h-auto max-w-70 max-h-54 lg:max-h-70",
                        attrs: { src: "/static/empty-measurement.png" }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass:
                        "flex flex-col items-center justify-between gap-4 py-4 lg:py-8 lg:flex-row"
                    },
                    [
                      _c("BlInputButton", {
                        attrs: { type: "plain", label: "Cancel" },
                        on: {
                          clicked: function($event) {
                            _vm.emptyMeasurmentsOpened = false
                          }
                        }
                      }),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass:
                            "flex flex-col items-center gap-4 lg:flex-row"
                        },
                        [
                          _c("BlInputButton", {
                            attrs: {
                              type: "outlined",
                              label: "Keep active and end session"
                            },
                            on: { clicked: _vm.onKeepActiveAndEndSession }
                          }),
                          _vm._v(" "),
                          _c("BlInputButton", {
                            attrs: { label: "Turn off all and end session" },
                            on: { clicked: _vm.onTrunOffAllAndEndSession }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ]
              )
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.endOpened
        ? _c("BlBackdrop", {
            staticClass: "bl-session-backdrop",
            attrs: {
              title: "Confirm to End Session",
              description: "Are you sure you want to end the session?",
              label: "Yes",
              submitLoading: _vm.endLoading,
              empty: ""
            },
            on: {
              "backdrop-close": function($event) {
                _vm.endOpened = false
              },
              "backdrop-action": _vm.endSession
            }
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.recommendationOpened
        ? _c("RecommendationPopup", {
            attrs: { recommendations: _vm.recommendations },
            on: { "close-modal": _vm.onCloseRecommendation }
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.shareOpened
        ? _c(
            "BlBackdrop",
            {
              staticClass: "bl-session-backdrop",
              attrs: {
                title: "Share session",
                cancelLabel: "Close",
                description:
                  "Share this session by copying the link or scanning the QR code below."
              },
              on: {
                "backdrop-close": function($event) {
                  _vm.shareOpened = false
                }
              }
            },
            [
              _c("div", { staticClass: "w-full px-4 lg:w-160 lg:px-8" }, [
                _c(
                  "div",
                  { staticClass: "bl-session-backdrop-input-wrapper" },
                  [
                    _c("BlInputText", { attrs: { input: _vm.linkInput } }),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "bl-session-backdrop-input-button" },
                      [
                        _c("BlInputButton", {
                          attrs: { icon: "copy", type: "outlined" },
                          on: { clicked: _vm.copyToClipboard }
                        })
                      ],
                      1
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "bl-session-backdrop-code" },
                  [
                    _c("QrcodeVue", {
                      attrs: {
                        value: _vm.linkInput.model,
                        size: 200,
                        level: "L"
                      }
                    })
                  ],
                  1
                )
              ])
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.welcomingMobile
        ? _c(
            "BlBackdrop",
            {
              attrs: { cancelLabel: "", footer: false },
              on: {
                "backdrop-close": function($event) {
                  _vm.welcomingMobile = false
                }
              }
            },
            [
              _c(
                "div",
                {
                  staticClass:
                    "fixed top-0 left-0 flex items-center justify-center w-full h-screen px-6"
                },
                [
                  _c(
                    "div",
                    {
                      staticClass:
                        "flex flex-col items-center justify-center max-w-md gap-6 mx-auto text-center"
                    },
                    [
                      _c(
                        "div",
                        {
                          staticClass:
                            "text-4xl font-bold text-light-purple font-logo"
                        },
                        [_vm._v("\n          Blüm\n        ")]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "space-y-3 text-center" },
                        [
                          _c("BlTextBody1", {
                            staticClass: "text-grey-400",
                            attrs: {
                              text: "You are about to begin a session with"
                            }
                          }),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass:
                                "flex items-center justify-center gap-4 text-center"
                            },
                            [
                              _c("Avatar", {
                                attrs: { name: _vm.client.name }
                              }),
                              _vm._v(" "),
                              _c("BlTextBody1", {
                                staticClass: "text-grey-400",
                                attrs: { text: _vm.client.name }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c("BlInputButton", {
                        staticClass: "w-full py-2",
                        attrs: { label: "Start the session" },
                        on: {
                          clicked: function($event) {
                            _vm.welcomingMobile = false
                          }
                        }
                      })
                    ],
                    1
                  )
                ]
              )
            ]
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-0b82ed14", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0b82ed14","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/sessions/Session.vue
// module id = null
// module chunks = 